import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Pipe({
  name: "serverResourcesPath",
})
export class ServerResourcesPathPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, folder: string, mode: string = ""): any {
    if (value == "") {
      return "";
    }

    if (!folder) {
      folder = "";
    }

    let url = "/api/files" + folder + "/" + value;

    let ret: SafeUrl;
    if (mode == "background_url") {
      ret = this.sanitizer.bypassSecurityTrustStyle("url('" + url + "')");
    } else if (mode == "no_sanitizer") {
      ret = url;
    } else {
      ret = this.sanitizer.bypassSecurityTrustUrl(url);
    }

    return ret;
  }
}
